<template>
  <div class="box02-body-detail-content"
    id="scroll-target"
    style="height:calc(100vh - 84px);"
    @scroll="handleScrollChild"
    >
    <FontawesomeIcon v-if="state.isLoadingDetail" :icon="['fal','spinner-third']" size="2x" class="mt100 icn fa-spin" />
    <template v-else>
      <ul class="note-editor">
        <li class="note-editor-item note-editor-block-01">
          <p class="note-editor-title">ノートのタイトル</p>
          <div class="formparts text">
            <input type="text" name="text" placeholder="株式会社Aの調査" ref="titleRef" v-model="detail.title">
            <p v-if="validate.title" class="error-message">{{validate.title}}</p>
          </div>
        </li>
        <li 
          v-show="state.isShareAreaShown"
          class="note-editor-item note-editor-block-02">
          <p class="note-editor-title">共有指定</p>
          <div class="formparts radio">
            <input type="radio" id="note_edit_01" 
              :value="1"
              v-model.number="detail.share_type"
              @change="share.onShareTypeChanged">
            <label role="button" for="note_edit_01">プライベート</label>
          </div>
          <div class="formparts radio mt10">
            <input type="radio" id="note_edit_02" 
              :value="2"
              v-model.number="detail.share_type"
              @change="share.onShareTypeChanged">
            <label role="button" for="note_edit_02">共有</label>
          </div>
          <p class="error-message" 
            v-if="detail.share_type === 2 && !state.isSaving && !share.isUsersToShareSelected"
            >アカウントを指定してください。</p>
          <div class="formparts-hidden"
            v-show="detail.share_type === 2">
            <div class="formparts radio mt10">
              <input type="radio" id="note_edit_21" 
                :value="21" 
                v-model.number="detail.share_classification"
                @click="share.onShareClassificationClicked(21, true)"
                :disabled="detail.share_type !== 2">
              <label role="button" for="note_edit_21">閲覧権限を付与する</label>
              <a class="txt-blue" role="button"
                v-if="detail.share_classification === 21 && share.isUsersToShareSelected"
                @click="share.onShareClassificationClicked(21, false)">閲覧・編集</a>
            </div>
            <div class="formparts radio mt10">
              <input type="radio" id="note_edit_22" 
                :value="22" 
                v-model.number="detail.share_classification"
                @click="share.onShareClassificationClicked(22, true)"
                :disabled="detail.share_type !== 2">
              <label role="button" for="note_edit_22">編集権限を付与する</label>
              <a class="txt-blue" role="button"
                v-if="detail.share_classification === 22 && share.isUsersToShareSelected"
                @click="share.onShareClassificationClicked(22, false)">閲覧・編集</a>
            </div>
          </div>
        </li>
        <li 
          v-show="state.isTagAreaShown"
          class="note-editor-item note-editor-block-03">
          <p class="note-editor-title">タグ</p>
          <div class="column al-center">
            <div class="column-item col-7">
              <div class="formparts function">
                <input type="text" @keydown.enter="tags.addTag" v-model="tags.newTag">
                <div @click="tags.addTag" class="button" role="button"><span class="icn register">登録</span></div>
              </div>
            </div>
            <div class="column-item col-5 space-left">
              <span role="button" class="txt-blue"
                @click="state.isOpenHistoryTags = !state.isOpenHistoryTags"
                :class="{'is-open' : state.isOpenHistoryTags}"
              >登録済のタグから追加
                <FontawesomeIcon icon="angle-down" class="icn" v-if="state.isOpenHistoryTags" />
                <FontawesomeIcon icon="angle-up" class="icn" v-else />
              </span>
            </div>
          </div>
          <div class="note-editor-tags note-editor-tags-history mt8"
            v-if="state.isOpenHistoryTags"
          >
            <div v-for="(history, index) in tags.history" :key="'history_tag_' + index" class="tag bottom">
              <div @click="tags.addEditTag(history)" role="button" class="tag-wrap">
                <span class="tag-text">{{history.name}}</span>
              </div>
            </div>
          </div>
          <div v-if="detail.tags.length > 0" class="note-editor-tags mt8">
            <div v-for="(tag, index) in detail.tags" :key="'detail_tag_' + index" class="tag">
              <div @click="tags.removeEditTag(tag)" role="button" class="tag-wrap">
                <span class="tag-text">{{tag.name}}</span>
                <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <VueDraggable class="note-editor-parts"
        draggable=".note-editor-parts-item"
        v-model="detail.lists"
        @end="listAction.drag.end"
      >
        <div role="button" slot="header" class="button plus is-top" @click="listAction.add.open(-1)">
            <span class="btn"><FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
        </div>
        <div v-for="(list, index) in detail.lists" :key="'parts_' + index" class="note-editor-parts-item">
          <template v-if="list.type === 0">
            <p class="note-editor-title">見出し</p>
            <div class="formparts text">
              <input type="text" v-model="list.content">
            </div>
          </template>
          <template v-else-if="list.type === 1">
            <p class="note-editor-title">コメント</p>
            <div class="formparts textarea">
              <textarea rows="5" v-model="list.content"></textarea>
            </div>
          </template>
          <template v-else-if="list.type === 2">
            <p class="note-editor-title">リンク</p>
            <p v-if="list.knowledge.deleted === 1" class="note-editor-parts-item-text">閲覧できなくなりました。</p>
            <div class="formparts text is-inactive">
              <input type="text" readonly v-model="list.knowledge.name">
            </div>
            <div class="mt20">
              <span class="note-editor-parts-item-sup"><span class="category-item">最新ナレッジ</span><span class="category-item">{{list.knowledge.knowledge_type_name}}</span></span>
              <span class="note-editor-parts-item-sup">{{formatDate(list.knowledge.created)}}</span>
            </div>
          </template>
          <template v-else-if="list.type === 3">
            <p class="note-editor-title">リンク</p>
            <!-- <p v-if="list.qa.deleted === 1" class="note-editor-parts-item-text">閲覧できなくなりました。</p> -->
            <p v-if="list.qa.auth_message">{{list.qa.auth_message}}</p>
            <!-- <p v-else-if="list.qa.latest_id && list.qa.id !== list.qa.latest_id" class="note-editor-parts-item-text">更新されました。</p> -->
            <div class="formparts text is-inactive">
              <input type="text" readonly v-model="list.qa.name">
            </div>
            <div class="mt20">
              <span class="note-editor-parts-item-sup">Q&A・事例</span>
              <span v-if="list.qa.year !== 'マスターインデックス'" class="note-editor-parts-item-sup">{{list.qa.year}}</span>
            </div>
          </template>
          <template v-else-if="list.type === 4">
            <p class="note-editor-title">リンク</p>
            <p v-if="list.pj.auth_message">{{list.pj.auth_message}}</p>
            <div class="formparts text is-inactive">
              <input type="text" readonly v-model="list.pj.name">
            </div>
            <div class="mt20">
              <span class="note-editor-parts-item-sup"><span class="category-item">資料</span></span>
              <span class="note-editor-parts-item-sup">{{formatDate(list.pj.created)}}</span>
            </div>
          </template>
          <div @click="listAction.copy.open(index)"><ButtonCopyOther /></div>
          <div @click="listAction.move.open(index, detail.lists.length)"><ButtonChangePosition /></div>
          <div @click="listAction.delete.open(index)"><ButtonClose/></div>
          <div @click="listAction.add.open(index)" class="button plus">
            <span role="button" class="btn"><FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
          </div>
        </div>
      </VueDraggable>
      <div class="note-editor-save button" :class="[!listAction.isInputDataValid && 'is-inactive']">
        <button @click="listAction.clickSave" 
          :disabled="!listAction.isInputDataValid"
          class="btn" type="button" name="button">保存</button>
      </div>
    </template>
    
    <!-- ノートの選択（コピー） -->
    <transition name="popup">
      <PCNoteSelect
        v-if="state.visibleNoteSelect"
        :type="state.targetListType"
        :pageId="state.targetListLinkId"
        :title="state.targetListContent"
        :note_row_id="state.targetNoteRowId"
        :currentNoteId="currentId"
        @closeSelectNote="listAction.copy.close"
      />
    </transition>

    <!-- ノート見出し・コメント追加 -->
    <transition name="popup">
      <PCNotePartAdd
        v-if="state.visibleNotePartAdd"
        @close="listAction.add.close"
        @addText="listAction.add.addText"
        @addTextarea="listAction.add.addTextarea"
      />
    </transition>

    <!-- ノート部位の移動 -->
    <transition name="popup">
      <PCNoteChangePosition
        v-if="state.visibleNoteChangePosition"
        @close="listAction.move.close"
        @move="listAction.move.move"
        :index="state.targetListIndex"
        :length="detail.lists.length - 1"
      />
    </transition>
    
    <!-- 部位の削除 -->
    <transition name="popup">
      <PCNotePartDeleteConfirm
        v-if="state.visibleNotePartDeleteConfirm"
        @close="listAction.delete.close"
        @delete="listAction.delete.delete"
        :type="state.targetListType"
      />
    </transition>

    <!-- 遷移時のアラート -->
    <transition name="popup">
      <PCNotePartPreventForgettingToSave
        v-if="state.visibleNotePartPreventForgettingToSave"
        @close="listAction.forget.close"
        @move="listAction.forget.move"
        @saveAndMove="listAction.forget.saveAndMove"
      />
    </transition>
  </div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

import VueDraggable from 'vuedraggable'
import PCNoteSelect from '@/components/pc/popup/PCNoteSelect.vue'
import PCNotePartAdd from '@/components/pc/popup/PCNotePartAdd.vue'
import PCNoteChangePosition from '@/components/pc/popup/PCNoteChangePosition.vue'
import PCNotePartDeleteConfirm from '@/components/pc/popup/PCNotePartDeleteConfirm.vue'
import PCNotePartPreventForgettingToSave from '@/components/pc/popup/PCNotePartPreventForgettingToSave.vue'

import { NoteEditPart } from '@/logic/note/NoteEditPart'
import { showNoteWarningDialog } from '@/logic/note/NoteWarningDialog'

export default defineComponent({
  components: {
    VueDraggable,
    PCNoteSelect,
    PCNotePartAdd,
    PCNoteChangePosition,
    PCNotePartDeleteConfirm,
    PCNotePartPreventForgettingToSave
  },
  setup (props, context) {
    return {
      showNoteWarningDialog,
      ...NoteEditPart(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
.box02-body {
  .box02-body-detail {
    transition: all .2s ease;
  }
  .box02-body-title {
    width: 30%;
    position: relative;
    &-navi {
      text-align: right;
      color: $color-link;
      font-size: 1.4rem;
      padding: 20px 40px;
      &-link {
        display: inline-block;
        @include hoverOpacity;
      }
    }
    &-list {
      list-style: none;
      &-item {
        padding: 4px 40px;
        min-height: 44px;
        display: flex;
        align-items: center;
        @include hoverOpacity;
        &.is-active {
          background-color: $color-selected;
        }
        &-title {
          width: calc(100% - 46px);
          color: $color-link;
        }
        &-prof {
          display: block;
          height: 36px;
          width: 36px;
          margin-left: 10px;
          background-position: center;
          background-size: cover;
          border-radius: 18px;
          border: 1px solid #fff;
        }
      }
    }
  }
  .box02-body-detail {
    width: 70%;
    border-left: 1px solid $color-line;
    &-menu {
      margin: 0 20px;
      &-item {
        display: inline-block;
        padding: 20px 0;
        color: $color-link;
        font-size: 1.6rem;
        font-weight: bold;
        position: relative;
        @include hoverOpacity;
        &.is-active:before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 100%;
          background-color: $color-yellow;
        }
        &-label {
          display: block;
          padding: 4px 20px;
          color: $color-link;
        }
        & + .box02-body-detail-menu-item .box02-body-detail-menu-item-label {
          border-left: 1px solid $color-line;
        }
      }
    }
    &-content {
      border-top: 1px solid $color-line;
      overflow-y: auto;
      padding-bottom: 120px;
    }
  }
  &.is-note-full {
    .box02-body-title {
      width: 0;
      visibility: hidden;
      opacity: 0;
    }
    .box02-body-detail {
      width: 100%;
    }
  }
}
.note-editor {
  list-style: none;
  &-item {
    padding: 32px 40px;
    border-bottom: 1px solid $color-line;
    &:last-child {
      border-bottom: 0;
    }
  }
  &-title {
    font-size: 2.0rem;
    color: $color-hdg;
    margin-bottom: 20px;
  }
  &-tags-history {
    border-bottom: 1px solid $color-line;
    padding-bottom: 20px;
  }
  &-block-02 {
    .error-message {
      margin: 8px 0 0;
      padding-left: 30px;
    }
    .formparts-hidden {
      margin-top: 16px;
      padding-left: 30px;
      .formparts {
        display: flex;
        align-items: center;
        a[role="button"] {
          margin-left: 8px;
        }
      }
    }
  }
  &-block-03 {
    .txt-blue {
      font-size: 1.4rem;
      @include hoverOpacity;
      .icn {
        margin-left: 5px;
      }
      .up {
        display: none;
      }
      &.is-open {
        .up {
          display: inline-block;
        }
        .down {
          display: none;
        }
      }
    }
  }
}
.note-editor-parts {
  border-top: 1px solid $color-line;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 6px;
    background-color: $color-bg-form;
  }
  &-item {
    border-bottom: 1px solid $color-line;
    position: relative;
    padding: 32px 140px 32px 40px;
    &.sortable-chosen {
      background-color: rgba(237,245,250, 0.5);
    }
    &-sup {
      display: inline-block;
      margin-right: 20px;
      color: $color-sup;
      font-size: 1.4rem;
    }
    &-link {
      display: flex;
      align-items: center;
      color: $color-link;
      margin-bottom: 12px;
      @include hoverOpacity;
      span {
        color: #fff;
        font-weight: bold;
        font-size: 2.0rem;
        margin-left: 5px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 27px;
        border-radius: 4px;
        background-color: $color-link;
      }
    }
    &-text {
      color: $color-content;
      margin-bottom: 12px;
    }
    .sort,
    .close,
    .copy {
      position: absolute;
      top: 50%;
      width: 34px;
      height: 34px;
      transform: translate3d(0,-50%,0);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: box-shadow .2s ease;
      &:hover {
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
      }
      .icn {
        position: absolute;
      }
    }
    .sort {
      right: 50px;
      .fa-angle-up {
        top: 5px;
      }
      .fa-angle-down {
        bottom: 5px;
      }
      .icn {
        color: $color-link;
      }
    }
    .close {
      right: 20px;
      .icn {
        color: $color-content;
        top: 50%;
        transform: translate3d(0,-50%,0);
      }
    }
    .copy {
      right: 80px;
      .icn {
        color: $color-link;
        top: 50%;
        transform: translate3d(0,-50%,0);
      }
    }
    .category-item:not(:last-child) {
      margin-right: 1em;
    }
  }
  .button.plus {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translate3d(-50%,0,0);
    width: 40px;
    height: 40px;
    z-index: 1;
    .btn {
      height: 40px;
    }
    &.is-top {
      bottom: auto;
      top: -20px;
    }
  }
}
.note-editor-save {
  margin: 52px auto 0;
  width: 230px;
}

</style>
